import BenchlingConfig from 'BenchlingConfig';
import Type from 'molbio/maps/Type';

export const SINGLE_PRIMER_BORDER = 1;

export const DEFAULT_TYPE = new Type(13);
// Height of text relative to overall primer height (accounting for tip) when bases are not shown
export const DEFAULT_BODY_RATIO = 2 / 3;
// Height of text relative to overall primer height (accounting for tip) when bases are shown
export const BASES_BODY_RATIO = 7 / 12;
// Height of mods relative to bases
export const MODIFICATION_HEIGHT_RATIO = 1 / 3;
// Height of margin relative to mods
export const MODIFICATION_MARGIN_RATIO = 1 / 2;
// Height of margin around primer bases relative to text
export const PRIMER_TEXT_MARGIN_RATIO = 1 / 5;

export function getSingleModificationHeight(type: Type): number {
  return MODIFICATION_HEIGHT_RATIO * type.height();
}

export function getModificationMarginHeight(type: Type): number {
  return MODIFICATION_MARGIN_RATIO * getSingleModificationHeight(type);
}

export function getTotalModificationHeight(type: Type): number {
  return getSingleModificationHeight(type) + 2 * getModificationMarginHeight(type);
}

export function getSinglePrimerInnerHeight(type: Type, includeMods: boolean, includeBases: boolean): number {
  const bodyRatio = includeBases ? BASES_BODY_RATIO : DEFAULT_BODY_RATIO;
  const baseHeight = type.height() / bodyRatio;
  return BenchlingConfig.MOLBIO_ENABLE_MODIFIED_NUCLEOTIDES && includeMods
    ? baseHeight + getTotalModificationHeight(type)
    : baseHeight;
}

export function getSinglePrimerHeight(type: Type, includeMods: boolean, includeBases: boolean): number {
  return 2 * SINGLE_PRIMER_BORDER + getSinglePrimerInnerHeight(type, includeMods, includeBases);
}
